import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  TellentGettingStartedProgressResponse,
  TellentGettingStartedResponse,
} from '@core/tellent-getting-started-types';
import { injectTellentAppKind } from '@core/tellent-types';

import { injectTellentGettingStartedHttp } from '../tellent-getting-started-http.service';

@Injectable({
  providedIn: 'root',
})
export class TellentGettingStartedHttpClient {
  #appKind = injectTellentAppKind();
  protected readonly httpApi = injectTellentGettingStartedHttp();

  public fetchContent(): Observable<TellentGettingStartedResponse> {
    return this.httpApi.get(`${this.resolveEndpointByAppKind()}`, null, null);
  }

  public fetchProgress(): Observable<TellentGettingStartedProgressResponse> {
    return this.httpApi.get(`${this.resolveEndpointByAppKind()}/progress`, null, null);
  }

  public dismissGuide(): Observable<TellentGettingStartedProgressResponse> {
    return this.httpApi.patch(`${this.resolveEndpointByAppKind()}/progress`, null, {
      status: 'dismissed',
    });
  }

  public updateStepProgress(steps: string[]): Observable<TellentGettingStartedProgressResponse> {
    return this.httpApi.patch(`${this.resolveEndpointByAppKind()}/progress`, null, {
      stepStatuses: Object.fromEntries(steps.map(step => [step, 'completed'])),
    });
  }

  private resolveEndpointByAppKind() {
    switch (this.#appKind) {
      case 'recruitment':
        return '/recruitment';

      case 'core_hr':
      case 'grow':
        return '/hr';

      default:
        throw new Error(`Unsupported app kind: ${this.#appKind}`);
    }
  }
}
